import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { paths } from "../../config/router.config";
import wsclients from "../../services/wsclients";
import SupportView from "./SupportView";
import CustomLoading from '../../components/CustomLoading';

export default function SupportController(props) {
    const { t } = useTranslation();
    const history = useHistory();

    const [active, setActive] = useState('pending');
    const rows = [
        { id: 112233, holder_name: 'Account and Billing', subject: 'Support Request-44', mess: 'send me invoice', default: 'True', status: 'Pending', prioty: 'low', datetime: '28/12/2021 12:06' },
        { id: 112234, holder_name: 'Account and Billing', subject: 'Support Request-44', mess: 'send me invoice', default: 'True', status: 'Pending', prioty: 'up', datetime: '28/12/2021 12:06' },
    ];
    const [serviceRequests, setServiceRequests] = useState([]);
    const [showLoading, onShowLoading] = useState(false);
    const [serviceRequestsCompleted, setServiceRequestsCompleted] = useState([]);

    useEffect(() => {
        getListServiceRequests();
        // getListServiceRequests('CLOSED');
    }, []);

    const getListServiceRequests = async (state) => {
        onShowLoading(true);
        try {
            let result = await wsclients.config.getListServiceRequests({});
            console.log("list service request==", result);
            if (result.code === 'OK' && result.data && result.data.content) {
                setServiceRequests(result.data.content);
                // else setServiceRequestsCompleted(result.data.content);
            }
        }
        catch(ex){
            console.log("exception getListServiceRequests==", ex);
        }
       onShowLoading(false);
    }

    const onChangeTab = (value) => {
        setActive(value);
    }

    const onAddSupportRequest = () => {
        history.push(paths.support_add);
    }

    return (
        <>
            <SupportView
                serviceRequests={serviceRequests}
                serviceRequestsCompleted={serviceRequestsCompleted}
                active={active}
                onChangeTab={onChangeTab}
                onAddSupportRequest={onAddSupportRequest}
            />
            {showLoading && <CustomLoading open={showLoading}/>}
        </>
    );
}